__turbopack_context__.v({
  "bolt": "Footer-module-scss-module__kqmR4W__bolt",
  "container": "Footer-module-scss-module__kqmR4W__container",
  "content": "Footer-module-scss-module__kqmR4W__content",
  "job-offer-tag": "Footer-module-scss-module__kqmR4W__job-offer-tag",
  "logo": "Footer-module-scss-module__kqmR4W__logo",
  "pages": "Footer-module-scss-module__kqmR4W__pages",
  "shape": "Footer-module-scss-module__kqmR4W__shape",
  "socials": "Footer-module-scss-module__kqmR4W__socials",
  "subscribe": "Footer-module-scss-module__kqmR4W__subscribe",
  "terms-and-conditions": "Footer-module-scss-module__kqmR4W__terms-and-conditions",
});
